(function(){
  function initSwiper(){
    if (!window.Swiper || !document.querySelector('.swiper-container')) return;
    new Swiper('.swiper-container', {
      slidesPerView: 3,
      spaceBetween: 30,
      loop: true,
      autoplay: { delay: 2500, disableOnInteraction: false },
      navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }
    });
  }
  document.addEventListener('DOMContentLoaded', initSwiper);
  window.addEventListener('load', initSwiper);
  document.addEventListener('shopify:section:load', function(e){
    if (e.detail && e.detail.sectionId && e.detail.sectionId.includes('ys_custom_gallery')) initSwiper();
  });
})();
